<template>
  <div class="dropdown" :class="{'open' : active}">
    <div class="input-container" :class="{'input-active' : searchText}">
      <div v-if="searchText" class="close-icon icon" @click="clear">
        <img :src="closeIcon">
      </div>
      <input id="keyword-search"
             ref="search"
             class="input-fields uk-search-input"
             :class="{'limit': inputLimit}"
             v-model="searchText"
             :disabled="keywordLimit"
             :placeholder="placeholder"
             @input="searchChanged"
             @keydown.esc="setOpen(false)"
             @blur="setOpen(false)"
             @keydown.enter="enterUtil()"
             @keydown.delete="setOpen(false)"
             v-on:keydown.enter.prevent
             @keydown.down="down"
             @keydown.up="up"
             autocomplete="off"
             maxlength="40">
      <div class="custom-overlay">
        <a @click="updateList(searchText)" class="toggle" for="search" v-if="!keywordLimit">
          <span class="add-icon"><img :src="addIcon"></span>
          <span class="add-icon-open"><img :src="addIconOpen"></span>
        </a>
      </div>
    </div>
    <ul class="suggestion-list">
      <li class="suggestion-title">{{$t('general.suggestions')}}</li>
      <li v-for="(suggestion, index) in matches"
          @mousedown.prevent
          @click="updateList(suggestion)"
          @mouseover="hoverUpdate(index)"
          :class="{'activeRow': index === highlightIndex}">
        <div class="suggestion-label-container">
          <div class="suggestion-label add-pointer">
            <a class="add-pointer suggestion" :value="suggestion">
              {{ suggestion }}
            </a>
          </div>
        </div>
      </li>
      <li v-if="!matches.length>0" class="no-suggestion-label"><a class="suggestion">{{$t('keywordsInput.noSuggestions')}}</a>
      </li>
    </ul>
    <ul class="selected-list">
      <li v-for="keyword in keywords" @mousedown.prevent>
        <div class="option-label-container add-pointer">
          <label class="option-label add-pointer">
            <img @click="removeSelectedOption(keyword)"
                 :data-src="keywordClose" class="icon-dimensions" uk-img>{{ keyword }}</label>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
  import iconUtil from '../../../utils/icon-util'
  import * as misc from '../../../enums/misc'
  import * as _ from 'lodash'

  export default {
    name: 'keywords-input',
    props: ['suggestions', 'limit', 'selectedKeywords', 'placeholder'],
    data() {
      return {
        searchText: '',
        lastSearchText: '',
        keywords: [],
        active: false,
        addIconOpen: iconUtil.resolve(misc.PLUS_BLUE),
        addIcon: iconUtil.resolve(misc.PLUS),
        keywordClose: iconUtil.resolve(misc.CLOSE_SLATE),
        dropdownClosed: iconUtil.resolve(misc.DROPDOWN_CLOSED),
        emptyCheckBox: iconUtil.resolve(misc.LRG_UNCHECKED),
        activeCheckbox: iconUtil.resolve(misc.LRG_CHECKED),
        closeIcon: iconUtil.resolve(misc.CLOSE_SLATE_14PX),
        highlightIndex: null,
        characterLimit: 40,
        inputLimit: false,
        keywordLimit: false
      }
    },
    methods: {
      removeSelectedOption(keyword) {
        let index = this.keywords.indexOf(keyword)
        this.keywords.splice(index, 1)
        this.$emit('keywordsInput', this.keywords)
        if (this.keywords.length === this.limit - 1) {
          this.placeholder = this.$t('uploadDetailsInput.keywordsPlaceholder')
          this.keywordLimit = false
        }
      },
      updateList(keyword) {
        if (!_.isEmpty(keyword) && this.keywords.length < this.limit) {
          if (!this.keywords.includes(keyword) && keyword.length <= this.characterLimit) {
            if (this.keywords.length === this.limit - 1) {
              this.placeholder = this.$t('uploadDetailsInput.keywordsPlaceholderLimit')
              this.keywordLimit = true
            }
            this.keywords.push(keyword)
            this.lastSearchText = this.searchText
            this.searchText = ''
            this.setOpen(false)
            this.$emit('keywordsInput', this.keywords)
          }
        }
      },
      searchChanged() {
        this.$emit('onChange', this.searchText)
        if (!this.active) {
          this.active = true
        }
      },
      setOpen(isActive) {
        this.active = isActive
        if (this.active) {
          this.$refs.search.focus()
        } else {
          this.highlightIndex = null
        }
      },
      updateComponentWithValue(newValue) {
        let list = this.suggestions
        if (Object.values(list).indexOf(newValue) > -1) {
          // Find the matching text for the supplied option value
          for (let text in list) {
            if (list.hasOwnProperty(text)) {
              if (list[text] === newValue) {
                this.searchText = text
              }
            }
          }
        }
      },
      up() {
        if (this.active) {
          if (this.highlightIndex > 0) {
            this.highlightIndex--
          }
        } else {
          this.setOpen(true)
        }
      },
      down() {
        if (this.active) {
          if (this.highlightIndex < this.matches.length - 1) {
            if (this.highlightIndex === null) {
              this.highlightIndex = 0
            } else {
              this.highlightIndex++
            }
          } else if (this.matches.length === 1) {
            this.highlightIndex = 0
          }
        } else {
          this.setOpen(true)
          this.highlightIndex = 0
        }
      },
      hoverUpdate(index) {
        this.highlightIndex = index
      },
      clear() {
        this.lastSearchText = this.searchText
        this.searchText = ''
      },
      enterUtil() {
        if (this.highlightIndex >= 0 && this.highlightIndex !== null) {
          this.updateList(this.matches[this.highlightIndex])
          this.setOpen(false)
        } else {
          this.updateList(this.searchText)
        }
      }
    },
    computed: {
      matches() {
        this.searchText = this.searchText || ''
        if (!_.isEmpty(this.searchText)) {
          return this.suggestions.filter((option) => {
            let optionText = option.toUpperCase()
            return optionText.match(this.searchText.toUpperCase().replace(/\s+/g, '.+'))
          })
        }
        return []
      }
    },
    watch: {
      searchText(input) {
        if (input.length === 40) {
          this.inputLimit = true
        } else {
          this.inputLimit = false
        }
      }
    },
    mounted() {
      this.updateComponentWithValue(this.value)
    },
    created() {
      if (this.selectedKeywords) {
        this.keywords = this.selectedKeywords
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '../../../styles/colours';
  @import '../../../styles/breakpoints';

  .input-container {
    width: 500px;
    position: relative;
  }

  .close-icon {
    position: absolute;
    padding: 13px 0 0 13px;
  }

  .icon {
    width: 43px;
    height: 43px;
  }

  .custom-overlay {
    top: 6%;
    left: 88.7%;
    position: absolute;
  }

  .open {
    .custom-overlay {
      top: 30%;
      left: 91%;
    }
  }

  .active {
    opacity: 0.8;
    background-color: $app-background;
  }

  .suggestion-title {
    font-size: 18px;
    font-weight: bold;
    padding: 8px 0px 13px 19px !important;
    height: 15px !important;
  }

  .suggestion-label {
    font-size: 18px;
    padding: 8px 0px 0px 19px !important;
  }

  .suggestions-label-container {
    height: 37px;
  }

  .suggestion-list {
    background-color: $suggestion-list;
    border: $suggestion-list-border;
    opacity: 1;
    list-style: none;
    display: block;
    padding: 0;
    width: 498px;
    position: absolute;
    top: 45px;
    left: 0;
    z-index: 2;
    margin-top: 20px;
    margin-left: 0px !important;
    overflow-x: hidden;
    overflow-y: auto;
    max-height: 300px;
    box-shadow: 3px 5px 8px 0 rgba(0, 0, 0, 0.24);

    li {
      width: 498px;
    }
  }

  .no-suggestion-label {
    padding: 12px 0px 11px 19px !important;
    font-size: 18px;
    color: #7a8b99;
    height: 15px !important;
  }

  .suggestion-list li:hover, .activeRow {
    background-color: $suggestion-list-hover;

    a.suggestion {
      color: $light-blue;

    }
  }

  a.suggestion {
    text-decoration: none;
    color: $content-text;
  }

  .dropdown.open .suggestion-list {
    display: block;
  }

  .dropdown .suggestion-list {
    display: none;
  }

  .dropdown {
    display: inline-block;
    position: relative;
  }

  .input-fields {
    width: 100%;
    border-radius: 1px;
    box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.24);
    background-color: white;
    font-size: 18px;
    color: $share-input-text;
    height: 46px;
    padding-left: 13px;

    &:hover, &:focus {
      border: 2px solid $light-blue;
      box-shadow: 3px 5px 8px 0 rgba(0, 0, 0, 0.24);
    }
  }

  .input-active {
    .input-fields {
      padding-left: 36px;
    }
  }

  .toggle .add-icon-open {
    display: none;
  }

  .open .custom-overlay .toggle .add-icon-open {
    display: inline-block;
  }

  .open .custom-overlay .toggle .add-icon {
    display: none;
  }

  .input-fields::placeholder {
    font-style: italic;
    font-size: 16px;
    color: $slate;
  }

  .input-fields:-ms-input-placeholder {
    font-style: italic !important;
    font-size: 16px !important;
    color: $slate !important;
  }

  .input-fields::-ms-input-placeholder {
    font-style: italic;
    font-size: 16px;
    color: $slate;
  }

  .input-checkbox {
    display: none;
  }

  .empty-checkbox {
    display: none;
  }

  .icon-dimensions {
    width: 34px;
    height: 34px;
  }

  li {
    list-style-type: none;
    display: inline-block;
    padding: 0px 13px 0px 0px;
    height: 37px;
    list-style-type: none;
  }

  ul {
    margin: 0 !important;
    padding: 12px 0px 0px 0px;

  }

  a:hover {
    font-weight: normal;
    color: $content-text;
    text-decoration: none;
  }

  .option-label-container {
    vertical-align: middle;
    display: inline-block;
    float: right;
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 14px;
    border-radius: 2px;
    background-color: #ffffff;
    padding-right: 10px;
    -webkit-box-shadow: 0 1px 3px 0 $drop-shadow-black;
    box-shadow: 0 1px 3px 0 $drop-shadow-black;

    &:hover {
      box-shadow: 3px 5px 8px 0 $drop-shadow-black;
    }
  }

  .option-label {
    font-size: 15px;
  }

  input::-ms-clear {
    display: none;
  }

  input.limit {
    text-decoration-line: underline;
    text-decoration-style: dotted;
    text-decoration-color: red;
  }

  @media screen and (max-width: $breakpoint-xlarge) {
    .input-container {
      width: 450px;
    }
    .suggestion-list {
      width: 450px;

      li {
        width: 449px;
      }
    }
  }
</style>
